import { Link } from "react-router-dom";
import { walletNoCard } from "../../../assets/imageImport";
import { PAGES } from "../../../routeConfig";
import { BacktoMyAccount } from "../backToMyAccount";

export const MyWalletNoCard = () => {
  return (
    <div className="col-lg-12">
      <div className="wallet-nosaved-Card p-5 mt-4">
        <div className="row">
          <div className="col-lg-6 offset-3 text-center mx-auto">
            <img src={walletNoCard} alt="No Saved Card" />
            <h2 className="fw-semibold">No Saved Cards</h2>
            <p className="fw-light col-fs-13">
              You don't seem to have saved any cards yet. Click on the button to
              add the first one
            </p>
            <div className="button-effect">
              <Link
                to={PAGES.MYWALLETADD}
                className="btn btn-products theme-primary mx-auto"
              >
                <i className="fa-solid fa-plus" /> Add New Card
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
